import React from "react";

const MigrationStage = ({ number, title, description, delay }) => {
  return (
    <div
      style={{ animationDelay: `${delay}s` }}
      className="about-fade-up group relative rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-md transition-all duration-300 hover:border-blue-400/30 hover:bg-white/[0.07] hover:-translate-y-1"
    >
      {/* Number */}
      <div className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-slate-900/50 text-lg font-extrabold text-white shadow-[0_0_20px_-6px_rgba(37,99,235,0.4)] transition-shadow duration-300 group-hover:shadow-[0_0_28px_-4px_rgba(37,99,235,0.5)]">
        {number}
      </div>

      {/* Text */}
      <h4 className="mt-4 font-raleway text-base font-bold text-white">
        {title}
      </h4>
      <p className="mt-2 font-openSans text-sm leading-relaxed text-slate-300">
        {description}
      </p>

      {/* Top accent line */}
      <div className="absolute left-0 right-0 top-0 h-1 rounded-t-2xl bg-gradient-to-r from-blue-500/60 to-violet-500/60 opacity-60 transition-opacity duration-300 group-hover:opacity-100" />
    </div>
  );
};

export default MigrationStage;
